const RENTALS_MESSAGES = {
  //getConversations
  RENTALS_CONVERSATIONS: 'RENTALS_CONVERSATIONS',
  //getConversationCounts
  RENTALS_CONVERSATIONS_COUNTS: 'RENTALS_CONVERSATIONS_COUNTS',
  //getConversationDetails
  RENTALS_CONVERSATION_DETAILS: 'RENTALS_CONVERSATION_DETAILS',
  //getUsers
  RENTALS_EMPLOYEES: 'RENTALS_EMPLOYEES',
  //getPropertyGalleries
  RENTALS_PROPERTY_GALLERIES: 'RENTALS_PROPERTY_GALLERIES',
  //getLanguages
  RENTALS_MESSAGES_LANGUAGES: 'RENTALS_MESSAGES_LANGUAGES',
  //getOffices
  RENTALS_MESSAGES_OFFICES: 'RENTALS_MESSAGES_OFFICES',
  //getPartners
  RENTALS_MESSAGES_PARTNERS: 'RENTALS_MESSAGES_PARTNERS',
  //getOpportunities
  RENTALS_MESSAGES_OPPORTUNITIES: 'RENTALS_MESSAGES_OPPORTUNITIES',
  //getOpportunityDetails
  RENTALS_OPPORTUNITY_DETAILS: 'RENTALS_OPPORTUNITY_DETAILS',
  //getOpportunityStatusTypes
  RENTALS_OPPORTUNITY_STATUS: 'RENTALS_OPPORTUNITY_STATUS',
  //getCountries
  RENTALS_MESSAGES_COUNTRIES: 'RENTALS_MESSAGES_COUNTRIES',
  //getAllProperties
  RENTALS_MESSAGES_PROPERTIES: 'RENTALS_MESSAGES_PROPERTIES',
  //getReservationTemplates
  RENTALS_MESSAGES_MAILTASKS: 'RENTALS_MESSAGES_MAILTASKS',
  //getReservationLogs
  RENTALS_RESERVATION_LOGS: 'RENTALS_RESERVATION_LOGS',
  //getTaskOpportunity
  RENTALS_TASK_OPPORTUNITY: 'RENTALS_TASK_OPPORTUNITY',
  //getTaskReservation
  RENTALS_TASK_RESERVATION: 'RENTALS_TASK_RESERVATION',
  //getLogDocument
  RENTALS_OPPORTUNITY_LOG_DOCUMENT: 'RENTALS_OPPORTUNITY_LOG_DOCUMENT',
  //getOpportunityTemplateDetails
  RENTALS_OPPORTUNITY_TEMPLATE_DETAILS: 'RENTALS_OPPORTUNITY_TEMPLATE_DETAILS',
  //getLogTypes
  RENTALS_LOG_TYPES_OPPORTUNITY: 'RENTALS_LOG_TYPES_OPPORTUNITY',
  //getWhatsAppTemplates
  RENTALS_WHATSAPP_TEMPLATES: 'RENTALS_WHATSAPP_TEMPLATES',
  //getWhatsAppPlaceholderSources
  RENTALS_WHATSAPP_PLACEHOLDER_SOURCES: 'RENTALS_WHATSAPP_PLACEHOLDER_SOURCES',
  //postWhatsAppReservationPreview
  RENTALS_WHATSAPP_RESERVATION_PREVIEW: 'RENTALS_WHATSAPP_RESERVATION_PREVIEW',
  //postWhatsAppConversationPreview
  RENTALS_WHATSAPP_CONVERSATION_PREVIEW: 'RENTALS_WHATSAPP_CONVERSATION_PREVIEW',
  //getWhatsAppLookups
  RENTALS_WHATSAPP_LOOKUPS: 'RENTALS_WHATSAPP_LOOKUPS',
};

export default RENTALS_MESSAGES;
